// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-CorporateCards-styles___paper--uoXdP {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-CompanyDetails-CorporateCards-styles___dropdown--WrWvu {
  padding: 15px;
  max-width: 736px;
}

.components-CompanyDetails-CorporateCards-styles___root--jNEdJ {
  width: 100%;
}

.components-CompanyDetails-CorporateCards-styles___menuItem--KAPhL {
  font-size: 15px;
  color: #1b2432 !important;
  line-height: 18px;
}

.components-CompanyDetails-CorporateCards-styles___listItem--fUjps {
  height: auto !important;
  padding-top: 8px;
  padding-bottom: 8px;
}

.components-CompanyDetails-CorporateCards-styles___location--cJTqV {
  margin-bottom: 5px;
}

.components-CompanyDetails-CorporateCards-styles___inputContainer--C9day {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-CompanyDetails-CorporateCards-styles___inputContainer--C9day.components-CompanyDetails-CorporateCards-styles___passportInfo--z1XKw {
    padding-bottom: 24px;
  }

.components-CompanyDetails-CorporateCards-styles___inputWrapper--dstuh {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-CompanyDetails-CorporateCards-styles___table--cFmK2 {
  margin: 20px 0 0;
}

.components-CompanyDetails-CorporateCards-styles___tableHead--uu8LS {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-CompanyDetails-CorporateCards-styles___tableRow--MNmsq {
  height: 68px !important;
}

.components-CompanyDetails-CorporateCards-styles___tableRow--MNmsq:last-child .components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4 {
      border: none;
    }

.components-CompanyDetails-CorporateCards-styles___tableRow--MNmsq.components-CompanyDetails-CorporateCards-styles___addNewTableRow--SlRKv {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4 {
  font-size: 15px !important;
  padding: 16px 10px 16px 0px !important;
  min-width: 105px !important;
}

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4.components-CompanyDetails-CorporateCards-styles___removeCell--yntAk {
    text-align: right;
    padding: 0 !important;
    width: 60px;
  }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4.components-CompanyDetails-CorporateCards-styles___removeCell--yntAk button {
      padding-left: 0;
      padding-right: 0;
      min-width: 44px;
    }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4.components-CompanyDetails-CorporateCards-styles___inputTableCell--qfTTx {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4.components-CompanyDetails-CorporateCards-styles___inputTableCell--qfTTx > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4.components-CompanyDetails-CorporateCards-styles___buttonTableCell--QvlzH {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4 .components-CompanyDetails-CorporateCards-styles___alertMessageCont--QY0Ju {
    display: flex;
    flex-direction: column;
  }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4 .components-CompanyDetails-CorporateCards-styles___alertMessageCont--QY0Ju .components-CompanyDetails-CorporateCards-styles___alertMessage--mm_OS {
      font-family: 'Roboto-Regular';
      font-size: 11px;
      color: #fc3b60 !important;
      letter-spacing: 0;
      margin-top: 4px;
    }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4 .components-CompanyDetails-CorporateCards-styles___alertMessageContInside--YZQz8 {
    display: flex;
    flex-direction: row;
    margin-top: 17px;
  }

.components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4 .components-CompanyDetails-CorporateCards-styles___alertMessageContInside--YZQz8 svg {
      margin-right: 5px !important;
    }

.components-CompanyDetails-CorporateCards-styles___extraMargin--OHllJ {
  padding-left: 21px !important;
}

.components-CompanyDetails-CorporateCards-styles___alertIcon--zvCcq {
  width: 16px !important;
  padding-right: 0 !important;
  min-width: 16px !important;
}

.components-CompanyDetails-CorporateCards-styles___emptyData--yPFfd {
  padding: 24px 0;
}

.components-CompanyDetails-CorporateCards-styles___buttons--owyfJ {
  border-top: 1px solid #dddee0;
  padding-top: 32px;
  display: flex;
  justify-content: flex-end;
}

.components-CompanyDetails-CorporateCards-styles___tabs--q4BB7,
.components-CompanyDetails-CorporateCards-styles___tab--nQQm0 {
  text-transform: initial !important;
}

.components-CompanyDetails-CorporateCards-styles___tabs--q4BB7 {
  border-bottom: 1px solid #c6c8cc;
  margin-top: 16px;
}

.components-CompanyDetails-CorporateCards-styles___tabs--q4BB7 .components-CompanyDetails-CorporateCards-styles___tab--nQQm0 {
    flex: 1;
    max-width: 100% !important;
  }

.components-CompanyDetails-CorporateCards-styles___companyInfoHeader--pyI_l {
  display: flex;
}

.components-CompanyDetails-CorporateCards-styles___companyInfoHeaderText--Cvvwr h2 {
  font-size: 21px;
  color: #1b2432;
  letter-spacing: 0;
  margin-bottom: 5px;
}

.components-CompanyDetails-CorporateCards-styles___companyInfoHeaderText--Cvvwr .components-CompanyDetails-CorporateCards-styles___description--fXKep {
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
}

.components-CompanyDetails-CorporateCards-styles___companyInfoHeaderText--Cvvwr {
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  margin-left: 22px;
}

.components-CompanyDetails-CorporateCards-styles___buttonEdit--UdvLB {
  width: 55px;
  height: 32px !important;
  font-size: 13px !important;
}

.components-CompanyDetails-CorporateCards-styles___buttonContainer--Nqli5 {
  border-top: 1px solid rgba(224, 224, 224, 1);
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
}

.components-CompanyDetails-CorporateCards-styles___buttonContainer--Nqli5 .components-CompanyDetails-CorporateCards-styles___button--XHwPI {
    width: 106px;
    height: 34px;
  }
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/CorporateCards/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AAKtB;;AAHE;IACE,oBAAoB;EACtB;;AAGF;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AAWzB;;AARI;MACE,YAAY;IACd;;AAGF;IACE,+CAA+C;EACjD;;AAGF;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,2BAA2B;AAoD7B;;AAlDE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EAOb;;AALE;MACE,eAAe;MACf,gBAAgB;MAChB,eAAe;IACjB;;AAGF;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAEA;IACE,aAAa;IACb,sBAAsB;EASxB;;AAPE;MACE,6BAA6B;MAC7B,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;IACjB;;AAGF;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAKlB;;AAHE;MACE,4BAA4B;IAC9B;;AAIJ;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAMlB;;AAJE;IACE,OAAO;IACP,0BAA0B;EAC5B;;AAGF;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AAKnB;;AAJE;IACE,YAAY;IACZ,YAAY;EACd","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.dropdown {\n  padding: 15px;\n  max-width: 736px;\n}\n\n.root {\n  width: 100%;\n}\n\n.menuItem {\n  font-size: 15px;\n  color: #1b2432 !important;\n  line-height: 18px;\n}\n\n.listItem {\n  height: auto !important;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.location {\n  margin-bottom: 5px;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n\n  &.passportInfo {\n    padding-bottom: 24px;\n  }\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 10px 16px 0px !important;\n  min-width: 105px !important;\n\n  &.removeCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 60px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n      min-width: 44px;\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n\n  .alertMessageCont {\n    display: flex;\n    flex-direction: column;\n\n    .alertMessage {\n      font-family: 'Roboto-Regular';\n      font-size: 11px;\n      color: #fc3b60 !important;\n      letter-spacing: 0;\n      margin-top: 4px;\n    }\n  }\n\n  .alertMessageContInside {\n    display: flex;\n    flex-direction: row;\n    margin-top: 17px;\n\n    svg {\n      margin-right: 5px !important;\n    }\n  }\n}\n\n.extraMargin {\n  padding-left: 21px !important;\n}\n\n.alertIcon {\n  width: 16px !important;\n  padding-right: 0 !important;\n  min-width: 16px !important;\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.buttons {\n  border-top: 1px solid #dddee0;\n  padding-top: 32px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n  margin-top: 16px;\n\n  .tab {\n    flex: 1;\n    max-width: 100% !important;\n  }\n}\n\n.companyInfoHeader {\n  display: flex;\n}\n\n.companyInfoHeaderText h2 {\n  font-size: 21px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-bottom: 5px;\n}\n\n.companyInfoHeaderText .description {\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n\n.companyInfoHeaderText {\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-left: 22px;\n}\n\n.buttonEdit {\n  width: 55px;\n  height: 32px !important;\n  font-size: 13px !important;\n}\n\n.buttonContainer {\n  border-top: 1px solid rgba(224, 224, 224, 1);\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 24px;\n  .button {\n    width: 106px;\n    height: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CompanyDetails-CorporateCards-styles___paper--uoXdP`,
	"dropdown": `components-CompanyDetails-CorporateCards-styles___dropdown--WrWvu`,
	"root": `components-CompanyDetails-CorporateCards-styles___root--jNEdJ`,
	"menuItem": `components-CompanyDetails-CorporateCards-styles___menuItem--KAPhL`,
	"listItem": `components-CompanyDetails-CorporateCards-styles___listItem--fUjps`,
	"location": `components-CompanyDetails-CorporateCards-styles___location--cJTqV`,
	"inputContainer": `components-CompanyDetails-CorporateCards-styles___inputContainer--C9day`,
	"passportInfo": `components-CompanyDetails-CorporateCards-styles___passportInfo--z1XKw`,
	"inputWrapper": `components-CompanyDetails-CorporateCards-styles___inputWrapper--dstuh`,
	"table": `components-CompanyDetails-CorporateCards-styles___table--cFmK2`,
	"tableHead": `components-CompanyDetails-CorporateCards-styles___tableHead--uu8LS`,
	"tableRow": `components-CompanyDetails-CorporateCards-styles___tableRow--MNmsq`,
	"tableCell": `components-CompanyDetails-CorporateCards-styles___tableCell--PlSl4`,
	"addNewTableRow": `components-CompanyDetails-CorporateCards-styles___addNewTableRow--SlRKv`,
	"removeCell": `components-CompanyDetails-CorporateCards-styles___removeCell--yntAk`,
	"inputTableCell": `components-CompanyDetails-CorporateCards-styles___inputTableCell--qfTTx`,
	"buttonTableCell": `components-CompanyDetails-CorporateCards-styles___buttonTableCell--QvlzH`,
	"alertMessageCont": `components-CompanyDetails-CorporateCards-styles___alertMessageCont--QY0Ju`,
	"alertMessage": `components-CompanyDetails-CorporateCards-styles___alertMessage--mm_OS`,
	"alertMessageContInside": `components-CompanyDetails-CorporateCards-styles___alertMessageContInside--YZQz8`,
	"extraMargin": `components-CompanyDetails-CorporateCards-styles___extraMargin--OHllJ`,
	"alertIcon": `components-CompanyDetails-CorporateCards-styles___alertIcon--zvCcq`,
	"emptyData": `components-CompanyDetails-CorporateCards-styles___emptyData--yPFfd`,
	"buttons": `components-CompanyDetails-CorporateCards-styles___buttons--owyfJ`,
	"tabs": `components-CompanyDetails-CorporateCards-styles___tabs--q4BB7`,
	"tab": `components-CompanyDetails-CorporateCards-styles___tab--nQQm0`,
	"companyInfoHeader": `components-CompanyDetails-CorporateCards-styles___companyInfoHeader--pyI_l`,
	"companyInfoHeaderText": `components-CompanyDetails-CorporateCards-styles___companyInfoHeaderText--Cvvwr`,
	"description": `components-CompanyDetails-CorporateCards-styles___description--fXKep`,
	"buttonEdit": `components-CompanyDetails-CorporateCards-styles___buttonEdit--UdvLB`,
	"buttonContainer": `components-CompanyDetails-CorporateCards-styles___buttonContainer--Nqli5`,
	"button": `components-CompanyDetails-CorporateCards-styles___button--XHwPI`
};
module.exports = ___CSS_LOADER_EXPORT___;
